/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import _forEach from 'lodash/forEach';
import DefConst from '../constants/def.constant';
import AppConst from '../constants/app.constant';
import ConfigDeviceSettings from '../config/device.config';

const rulesetService = () => {
  const content = {};
  let forecast;
  let cellLvl;
  let cellContent;
  let thresholds;
  let numColumns;
  let cellColor;
  let cellLbl;
  let ruleset;
  let rulesets;
  const cellAlerts = [];

  function setNumColumns(data) {
    if (data.forecast) {
      numColumns = data.forecast.length;
    }
  }

  function loadRuleset(selectedRuleset) {
    ruleset = selectedRuleset;
    thresholds = rulesets[ruleset];
    // console.log(thresholds);
    cellColor = ['silver'].concat(thresholds.clr);
    cellLbl = ['silver'].concat(thresholds.lbl);
    cellAlerts.length = 0;
  }

  function processForecastValue(fcVar, fcVal, lowHigh, lvl2, lvl3, lvl4, lvl5, cellNum) {
    let fcValLvl = 0;

    if (fcVal === null) {
      if (fcVar === 'wsp' || fcVar === 'rlh') {
        cellLvl = 0;
      }
      return;
    }
    if (lowHigh === 'low') {
      if (lvl5) {
        if (fcVal <= lvl5) {
          fcValLvl = 5;
        }
      }
      if (lvl4 && (fcValLvl === 0)) {
        if (fcVal <= lvl4) {
          fcValLvl = 4;
        }
      }
      if (lvl3 && (fcValLvl === 0)) {
        if (fcVal <= lvl3) {
          fcValLvl = 3;
        }
      }
      if (lvl2 && (fcValLvl === 0)) {
        if (fcVal <= lvl2) {
          fcValLvl = 2;
        }
      }
      if (fcValLvl === 0) {
        fcValLvl = 1;
      }
    } else {
      if (lvl5) {
        if (fcVal >= lvl5) {
          fcValLvl = 5;
        }
      }
      if (lvl4 && (fcValLvl === 0)) {
        if (fcVal >= lvl4) {
          fcValLvl = 4;
        }
      }
      if (lvl3 && (fcValLvl === 0)) {
        if (fcVal >= lvl3) {
          fcValLvl = 3;
        }
      }
      if (lvl2 && (fcValLvl === 0)) {
        if (fcVal >= lvl2) {
          fcValLvl = 2;
        }
      }
      if (fcValLvl === 0) {
        fcValLvl = 1;
      }
    }
    if (cellLvl > 0 && cellLvl < fcValLvl) {
      cellLvl = fcValLvl;
    }
    if (fcValLvl > 1) {
      cellContent.push({
        rule_level: fcValLvl,
        cellColor: cellColor[fcValLvl],
        fcVar: fcVar.substr(0, 1).toUpperCase(),
      });
      if (cellNum || cellNum === 0) {
        if (!cellAlerts[cellNum]) {
          cellAlerts[cellNum] = [];
        }
        cellAlerts[cellNum].push({
          fcVar,
          fcVal,
          fcValLvl,
        });
      }
    }
  }
  function processForecastValuesInterface(cellNum) {
    Object.keys(thresholds).forEach((threshold) => {
      processForecastValue(
        threshold,
        forecast.forecast[cellNum][threshold],
        thresholds[threshold][0],
        thresholds[threshold][2],
        thresholds[threshold][3],
        thresholds[threshold][4],
        thresholds[threshold][5],
        cellNum,
      );
    });
  }
  function renderTable() {
    let cellNum;
    let i = 0;
    let j = 0;
    let rowCount;
    const flightRuleData = [];
    let forecastRule;
    if (forecast && forecast.forecast) {
      rowCount = forecast.forecast.length;
      cellAlerts.length = 0;
      while (i < rowCount / numColumns) {
        while (j < numColumns) {
          forecastRule = {};
          if (!forecastRule.cellContent) {
            forecastRule.cellContent = [];
          }
          forecastRule.icao_id = forecast.forecast[i * numColumns].icao_id;
          cellLvl = 1;
          cellContent = [];
          cellNum = (i * numColumns) + j;
          processForecastValuesInterface(cellNum);
          forecastRule.rule_level = cellLvl - 1;
          forecastRule.cellColor = cellColor[cellLvl];
          forecastRule.cellLbl = cellLbl[cellLvl];
          forecastRule.cellContent.push(cellContent);
          flightRuleData.push(forecastRule);
          j += 1;
        }
        i += 1;
      }
    }
    return flightRuleData;
  }

  content.getRuleSetData = (data, settings) => {
    forecast = data;
    setNumColumns(data);
    rulesets = DefConst.factoryRuleSetMap;
    ruleset = settings.ruleset;
    loadRuleset(ruleset);
    return {
      flightRuleData: renderTable(),
      cellAlerts,
    };
  };
  content.loadRulesetConfiguration = (rulesetvalue) => {
    if (ConfigDeviceSettings.settings.enableAlternateColorScheme) {
      // use different color sceme "i"
      const whichRuleset = rulesetvalue || AppConst.alternateColorSchemeRuleKey;
      DefConst.rulesetColorMapping = [];
      DefConst.rulesetLblMapping = [];
      _forEach(DefConst.factoryRuleSetMap[whichRuleset].clr, (item, key) => {
        DefConst.rulesetColorMapping.unshift(item);
        DefConst.rulesetLblMapping.unshift(DefConst.factoryRuleSetMap[whichRuleset].lbl[key]);
      });
    } else {
      DefConst.rulesetColorMapping = ['magenta', 'red', '#3366FF', 'green'];
      DefConst.rulesetLblMapping = ['LIFR', 'IFR', 'MVFR', 'VFR'];
    }
  };
  return content;
};
export default rulesetService();
